import { Controller } from "@hotwired/stimulus"

// A modal <dialog> opened from a button next to it: Esc or a click on the
// backdrop closes it. `open` opens it on load (a link from a list's menu).
export default class extends Controller {
  static targets = ["dialog"]
  static values = { open: Boolean }

  connect() {
    if (this.openValue) this.open()
  }

  open() {
    this.dialogTarget.showModal()
    this.dialogTarget.querySelector("input, select, textarea")?.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
